import { render, staticRenderFns } from "./List.vue?vue&type=template&id=ca83a36c&scoped=true"
import script from "./List.ts?vue&type=script&lang=ts&external"
export * from "./List.ts?vue&type=script&lang=ts&external"
import style0 from "./List.vue?vue&type=style&index=0&id=ca83a36c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca83a36c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca83a36c')) {
      api.createRecord('ca83a36c', component.options)
    } else {
      api.reload('ca83a36c', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=ca83a36c&scoped=true", function () {
      api.rerender('ca83a36c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/BillingErrors/pages/List/List.vue"
export default component.exports